import Accordion from './accordion';

export default {
  init: function (selector) {
    const accordions = document.querySelectorAll(selector);

    if (accordions && accordions.length) {
      [...accordions].forEach(item => {
        const accordion = new Accordion(item);
        accordion.init();
      });
    }
  }
};
